module.exports = __webpack_public_path__ + "static/media/cctv.a130e778.svg";